module.exports = __webpack_public_path__ + "media/assets/cloudroom-safari-29bf0717287f3788648b6c2e7e686cd7.png";